<template>
    <el-dialog
        :title="$t('TABLE_HEADER_clientUserName')"
        :visible.sync="show"
        :close-on-click-modal="false"
        width="400px"
        @close="show = false"
    >
        <el-select
            v-model="value" 
            style="width: 100%"
            clearable
            filterable>
            <el-option
                v-for="(v, k) in options"
                :key="k"
                :label="`${v.userName} (${v.email})`"
                :value="v.id">
            </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
            <el-button class="wl-green" @click="onConfirmHere">{{ $t('btn_submit') }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: 'ItuUpdateClient',
    data() {return {
        
    }},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        options: {
            type: Array,
            default: () => []
        },
        onConfirm: {
            type: Function,
            default: () => {}
        },
        value: {
            type: String,
            default: ''
        }
    },
    methods: {
        async onConfirmHere() {
            this.onConfirm && this.onConfirm(this.value)
        }
    },
    watch: {
        show(v) {
            this.$emit('update:show', v)
        },
        value(v) {
            this.$emit('update:value', v)
        }
    }
}
</script>